import React from 'react';
import { Link } from 'react-router-dom';

function Header() {
  return (
    <header class="wrapper header-wrapper">
        <div class="container">
            <div class="row">
                <div class="col-sm-3">
                    <div id="logo">
                        <Link to="/"><img src="https://www.technowebsol.com/image/catalog/logo.png" title="Techno Web Solutions" alt="Techno Web Solutions" class="img-responsive" /></Link>
                    </div>
                </div>
                <div class="col-sm-9">
                    <nav id="menu" class="navbar">
                        <div class="navbar-header">
                            <button type="button" class="btn btn-navbar navbar-toggle" data-toggle="collapse" data-target=".navbar-ex1-collapse"><i class="fa fa-bars"></i></button>
                        </div>
                        <div class="collapse navbar-collapse navbar-ex1-collapse">
                            <ul class="nav navbar-nav pull-right">
                                <li class="active"><Link to="/">Home</Link></li>
                                <li><Link to="/about-us.html">About Us</Link></li>
                                <li><Link to="/services.html">Services</Link></li>
                                <li><Link to="/portfolio.html">Portfolio</Link></li>
                                <li><Link to="/ourteam.html">Our Team</Link></li>
                                <li><Link to="/get-a-quote.html">Get a Quote</Link></li>
                                <li><Link to="/contact-us.html">Contact us</Link></li>
                            </ul>
                        </div>
                    </nav>
                </div>
            </div>
        </div>
    </header>
  )
}

export default Header